module.exports = __webpack_public_path__ + "static/section_check_info1-9baa9b75ae136fb1732826f312648ee6.png";